module.exports = __webpack_public_path__ + "static/media/banos.b49e7b20.png";